module.exports = __webpack_public_path__ + "static/_colorbase_-be39d9e3ff1a351bb7e16119388a7961.png";